module.exports = __webpack_public_path__ + "img/empty-img.61c54534.svg";